import Dexie, { type EntityTable } from 'dexie';

import { Logger } from '@eluve/logger';

import { UploadType } from './types';

export type AppointmentFileIdbRow = {
  id: string;
  appointmentId: string;
  lastUploadAttemptedAt: string;
  attemptCount: number;
  wasDegraded: boolean;
  segmentId?: string;
  chunkNum?: number;
  uploadType?: UploadType;
  chunkDurationMinutes?: number;
  shouldBeTranscribed: boolean | undefined;
};

export const createDb = ({
  userId,
  tenantId,
  logger,
}: {
  userId: string;
  tenantId: string;
  logger: Logger;
}) => {
  const db = new Dexie(`${userId}-${tenantId}`) as Dexie & {
    appointmentFiles: EntityTable<AppointmentFileIdbRow, 'id'>;
  };

  db.version(1).stores({
    appointmentFiles: 'id, appointmentId, lastUploadAttemptedAt, attemptCount',
  });

  db.open().then(() => logger.info('Dexie opened and migrated'));

  return db;
};

export type DexieDb = ReturnType<typeof createDb>;
